import React, {Component} from 'react';
import {Breadcrumb} from 'semantic-ui-react';
import {Helmet} from "react-helmet";

import ExpenseData from "../../data/ExpenseData";
import CustomDivider from '../../components/extras/CustomDivider';
import {connect} from "react-redux";
import {openModalExpense} from "../../actions/ModalExpenseActions";
import {showToast} from "../../actions/ToastAction";
import DynamicTable from "../../components/extras/DynamicTable";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import ExpenseDialog from "../../components/expenses/ExpenseDialog";
import QuestionDialog from "../../components/extras/QuestionDialog";
import localDB from "../../data/localDB";
import {Link} from "react-router-dom";

class Expenses extends Component {
    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Fecha de Ingreso', 'Fecha', 'Usuario', 'Factura', 'Categoría', 'Valor', 'Acciones'],
                name: 'Gasto',
                title: 'Gastos',
                has_actions: true,
                edit: true,
                pagination: true,
                delete: true,
                can_add: localDB.get('rol_access').includes('add_expense'),
                url: 'expenses',
                values: ['id', 'date_creation', 'user', 'date', 'invoice_number', 'type_name', 'amount'],
                money_fields: ['amount'],
                datetime_fields: ['date_creation'],
                child_fields: [{'user':'full_name'}],
                date_fields: ['date'],
                id: 'table_expenses'
            },
        };
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.expense_select && nextProps.expense_select.hasOwnProperty('id')){
            this.props.dynamicTableAddOrUpdate(nextProps.expense_select);
        }
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'edit'){
            this.props.openModalExpense({show:true, expense:response.data});
        }else if(response.event === 'delete'){
            this.refs.deleteDialog.open('', response.data.id);
        } else if(response.event === 'add'){
            this.props.openModalExpense({show:true, expense:null});
        }
    };

    delete = (id) => {
        ExpenseData.delete(id, (res) => {
            if (res === null) {
                this.props.dynamicTableDelete(id);
                this.props.showToast({message:'Gasto Borrado!', type:'success'});
            } else {
                this.props.showToast({message:'Tenemos un problema!', type:'error'});
            }
        });
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Gastos - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/sales'>Finanzas</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Gastos</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable} />
                <QuestionDialog ref="deleteDialog" message="Borrar este gasto" callbackConfirm={this.delete}/>
                <ExpenseDialog location='expenses'/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        expense_select: state.get('expense_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        openModalExpense(modal){
            dispatch(openModalExpense(modal))
        },
        showToast(toast){
            dispatch(showToast(toast))
        },
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Expenses)




// WEBPACK FOOTER //
// ./src/containers/expenses/Expenses.js